import { fieldStyle } from '../../dashboards/primitives';
import { Field } from '../../dashboards/venues/venueCreateFields';
import type { PrivateEventForm } from '../usePrivateEventForm';

import { COLUMN, requiredProps, TWO_COLUMNS } from './step-layout';

/** Step 2: who the event is for, and who to reach on the day. */
export default function ClientStep({ form }: { form: PrivateEventForm }) {
  const { fields, set, fieldError } = form;
  const style = (key: string) => fieldStyle(fieldError(key) ? 'error' : undefined);
  return (
    <div style={COLUMN}>
      <Field label="Client name" required error={fieldError('clientName')}>
        <input
          aria-label="Client name"
          {...requiredProps(fieldError('clientName'))}
          value={fields.clientName}
          onChange={(e) => set('clientName', e.target.value)}
          style={style('clientName')}
        />
      </Field>
      <Field label="Headcount" required error={fieldError('headcount')}>
        <input
          aria-label="Headcount"
          {...requiredProps(fieldError('headcount'))}
          type="number"
          min={0}
          value={fields.headcount}
          onChange={(e) => set('headcount', e.target.value)}
          style={style('headcount')}
        />
      </Field>
      <Field label="Contact name" error={fieldError('contactName')}>
        <input
          aria-label="Contact name"
          value={fields.contactName}
          onChange={(e) => set('contactName', e.target.value)}
          placeholder="Name"
          style={style('contactName')}
        />
      </Field>
      <div style={TWO_COLUMNS}>
        <Field label="Contact email" error={fieldError('contactEmail')}>
          <input
            aria-label="Contact email"
            aria-invalid={fieldError('contactEmail') ? true : undefined}
            type="email"
            value={fields.contactEmail}
            onChange={(e) => set('contactEmail', e.target.value)}
            placeholder="name@company.com"
            style={style('contactEmail')}
          />
        </Field>
        <Field label="Contact phone" error={fieldError('contactPhone')}>
          <input
            aria-label="Contact phone"
            aria-invalid={fieldError('contactPhone') ? true : undefined}
            type="tel"
            value={fields.contactPhone}
            onChange={(e) => set('contactPhone', e.target.value)}
            placeholder="(555) 123-4567"
            style={style('contactPhone')}
          />
        </Field>
      </div>
    </div>
  );
}
